import { createContext, useReducer, Dispatch, ReactNode, useContext } from "react";
import { searchReducer, SearchActions } from "./reducers";

type InitialStateType = {
	phrase: string;
	filters: SearchFiltersType;
};

export type SearchFiltersType = { [key: string]: string[] };

const initialState: InitialStateType = {
	phrase: "",
	filters: {},
};

const SearchContext = createContext<{
	state: InitialStateType;
	dispatch: Dispatch<SearchActions>;
}>({
	state: initialState,
	dispatch: () => null,
});

const SearchProvider = ({ children }: { children: ReactNode }) => {
	const [state, dispatch] = useReducer(searchReducer, initialState);

	return <SearchContext.Provider value={{ state, dispatch }}>{children}</SearchContext.Provider>;
};

function useSearchContext() {
	return useContext(SearchContext);
}

export { SearchProvider, SearchContext, useSearchContext };
